<div class="box">
    <img src="./../../../assets/logo-transparent.png" alt="" class="logo">
    <h1><strong>EDUCATION SYSTEM</strong></h1>
    <router-outlet></router-outlet>
</div>

